"use strict";

require("@patsnap-biz/suggestion-board/lib/style");
require("@patsnap-biz/workspace-folder-tree/lib/style");
require("@patsnap-biz/icon/lib/style");
require("@patsnap-biz/virtual-tree/lib/style");
require("@patsnap-biz/text-truncate/lib/style");
require("./index.scss");